import React from 'react';
import { Grid } from '@mui/material';
import DocumentListVault from '../../document-vault/components/document-list-vault/DocumentListVault';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { EmploymentCategoryContent } from './EmploymentCategoryContent';
import { ProgressOverlay } from '../../../common/progress-overlay/ProgressOverlay';
import { RootState } from '../../../store';
import DocumentsBlock, {
  DocumentsActionsProps,
} from '../../../common/documents-block/DocumentsBlock';

interface DocumentsTabsProps {
  documents: any[];
  key: string;
  cardView?: boolean;
  workflow?: string | null;
  setWorkflow?: React.SetStateAction<any>;
  docsLoading?: string;
  showWorkflowBreadcrumbs?: boolean;
  setShowWorkflowBreadcrumbs?: React.SetStateAction<any>;
  /** Pagination + card / list switcher, attached to the documents table / workflow cards. */
  documentsActions?: DocumentsActionsProps;
}

const DocumentsTabs: React.FC<DocumentsTabsProps> = ({
  documents,
  setWorkflow,
  workflow,
  cardView,
  showWorkflowBreadcrumbs,
  setShowWorkflowBreadcrumbs,
  documentsActions,
}) => {
  const documentUploadsLoading = useAppSelector((state: RootState) => state.documents.status);

  return (
    <Grid component='div' container wrap='nowrap'>
      <Grid component='div' size={{ xs: 12 }}>
        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <FilterDrawer sections={filterSections} onApplyFilters={handleApplyFilters} />
        </Box> */}
        {cardView ? (
          <EmploymentCategoryContent
            documents={documents}
            cardView={cardView}
            documentsActions={documentsActions}
            workflow={workflow}
            setWorkflow={setWorkflow}
            showWorkflowBreadcrumbs={showWorkflowBreadcrumbs}
            setShowWorkflowBreadcrumbs={setShowWorkflowBreadcrumbs}
          />
        ) : (
          <DocumentsBlock actions={documentsActions}>
            <DocumentListVault documents={documents} compact embedded={!!documentsActions} />
            {documentUploadsLoading === 'loading' && <ProgressOverlay position='absolute' />}
          </DocumentsBlock>
        )}
      </Grid>
    </Grid>
  );
};

export default DocumentsTabs;
